/**
 * Delete lot handler.
 */
import { handleDeleteLot } from '../../modules/bulkOperations';
import { applyRemoteSnapshot } from '../../modules/lotOperations';
import type { TableHandlerDeps } from './types';

export function handleDelete(id: string, e: Event, deps: TableHandlerDeps): void {
  const { state, render, ensureAccessToken } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();
  handleDeleteLot(lot, state, render, applyRemoteSnapshot, ensureAccessToken, false);
}
